import Typography, { TypographyProps } from '@mui/material/Typography';
import type { ReactNode } from 'react';


interface HeadingProps extends Omit<TypographyProps, 'variant'> {
  children: ReactNode;
}

export const H1 = ({ children, ...props }: HeadingProps & { hero?: boolean }) => (
    <Typography
        variant={props.hero ? 'h1' : 'h2'}
        component="h1"
        {...props}
        sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3.75rem' }, ...props.sx }}
    >
        {children}
    </Typography>
);

export const H2 = ({ children, ...props }: HeadingProps) => (
    <Typography variant="h2" component="h2" {...props}>
        {children}
    </Typography>
);

export const H3 = ({ children, ...props }: HeadingProps) => (
    <Typography variant="h3" component="h3" {...props}>
        {children}
    </Typography>
);

export const H4 = ({ children, ...props }: HeadingProps) => (
    <Typography variant="h4" component="h4" {...props}>
        {children}
    </Typography>
);

export const H5 = ({ children, ...props }: HeadingProps) => (
    <Typography variant="h5" component="h5" {...props}>
        {children}
    </Typography>
);

export const H6 = ({ children, ...props }: HeadingProps) => (
    <Typography variant="h6" component="h6" {...props}>
        {children}
    </Typography>
);

// Convenience export for all headings
export const Headings = {
    H1,
    H2,
    H3,
    H4,
    H5,
    H6
};

export default Headings;
